import { render, staticRenderFns } from "./DummyApp.vue?vue&type=template&id=1435c038&scoped=true"
import script from "./DummyApp.vue?vue&type=script&lang=ts"
export * from "./DummyApp.vue?vue&type=script&lang=ts"
import style0 from "./DummyApp.vue?vue&type=style&index=0&id=1435c038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1435c038",
  null
  
)

export default component.exports